/**
 * C1 参考片口播逐句分析(2026-10-10 冻结契约):
 * `POST /api/v1/explosive/blueprints/{id}/lines`(body 空)→ `{ lines, cached }`。
 *
 * 数字人 / 新闻舱两个出口共用 —— 与 features/explosive 的 explosiveService 不同层
 * (entities 不能反向 import features),各自一行。
 * 首次进页 api 调 ai 补算并写回 `breakdown.lines`,第二次直接回缓存(cached=true)。
 * 无口播 → `lines=[]`,调用方退回「按公式生成」;ai 失败 → 503 人话报错,同样退回。
 */
import { api } from "@/shared/api";

import { parseBlueprintLines, type BlueprintLinesResult } from "../model/blueprintLines";

export const blueprintLinesService = {
  analyze: async (blueprintId: number): Promise<BlueprintLinesResult> => {
    const r = await api.post<{ lines?: unknown; cached?: unknown }>(
      `/explosive/blueprints/${blueprintId}/lines`,
      {}
    );
    return { lines: parseBlueprintLines(r?.lines), cached: r?.cached === true };
  },
};
